import { render, staticRenderFns } from "./spaceDialog.vue?vue&type=template&id=229b00a6&scoped=true"
import script from "./spaceDialog.vue?vue&type=script&lang=js"
export * from "./spaceDialog.vue?vue&type=script&lang=js"
import style0 from "./spaceDialog.vue?vue&type=style&index=0&id=229b00a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b00a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229b00a6')) {
      api.createRecord('229b00a6', component.options)
    } else {
      api.reload('229b00a6', component.options)
    }
    module.hot.accept("./spaceDialog.vue?vue&type=template&id=229b00a6&scoped=true", function () {
      api.rerender('229b00a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/spaceDialog.vue"
export default component.exports